import { configureStore, isPlain } from '@reduxjs/toolkit';

import { setStore } from '@vlabs/shared/redux/store';

import { initWSAfterAuth } from './initWSAfterAuth';
import { rootReducer } from './rootReducer';

const isSerializable = (value) => value instanceof Date || isPlain(value);

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      isSerializable,
    },
  }),
});

let wsInitialized = false;

const unsubscribe = store.subscribe(() => {
  const {
    account: { isAuthenticated },
    app: { features },
  } = store.getState();

  if (
    isAuthenticated
    && features?.state === 'loaded'
    && !wsInitialized
  ) {
    wsInitialized = true;
    store.dispatch(initWSAfterAuth);
    unsubscribe();
  }
});

setStore(store);
export const { getState } = store;
export { store };
